export enum TipoOperacaoEnum {
  CREDITO = 'L',
	REPASSE = 'R'
}

export interface TipoOperacao {
  nome: string;
  valor: TipoOperacaoEnum;
}